import React, { useEffect } from 'react';
import IPage from '../../interfaces/page'

const ContactPage: React.FunctionComponent<IPage> = () => {
    useEffect(() => {
    }, [])

    return <div>Contact Page</div>
}

export default ContactPage